export default {
  welcomealert: 'First time around?',
  tourlink: 'Tour the changes',
  title: 'Welcome to the New HKLII',
  step1: 'New Layout',
  step2: 'Searching on HKLII',
  step3: 'Advanced Search',
  step4: 'Noteup',
  step5: 'Viewing Legislation',
  title1: '3-column layout for different devices',
  title2: 'All-in-one search bar',
  title3: 'Search in specific fields in Advanced Search',
  title4: 'Finding Relevant Documents with Noteup',
  title5: 'Improved navigation for Legislations',
  title6: "That's a wrap!",
  desc1: [
    'The left column is for information related to the current content, right is <b>relavent links</b> to other locations.',
    'When visiting from mobile you can find the columns located top to bottom.',
    'You can use the <b>scrolling buttons</b> on the bottom right corner to qickly reach the top or end of the page.'
  ],
  desc2: [
    'You can search for {0} in HKLII databases with this search bar. You can {1} in this bar.',
    'The top-right header search bar is identical to the one on the homepage.'
  ],
  desc3: [
    'Advanced Search is for <b>multi-field searches</b>. Operators are not usable on this page.',
    '"Advanced query" input in Classic HKLII is merged with the normal search.'
  ],
  desc4: [
    '<b>Noteup</b> is a <b>search of other documents mentioning</b> the document you are reading.'
  ],
  desc5: [
    'Click on the <b>Show All</b> button to view all sections of a legislation at once. Click on <b>Table of Contents</b> to go to a list of sections for the Legislation.',
    'Click on the <b>arrows</b> to navigate between sections of the same legislation.',
    'Go to <b>Related Ordinance (Regulations)</b> to quickly access the items.'
  ],
  desc6: [
    "You've tour around the changes and new features we added to the site. Be sure to give us a {rating} or {email} if there are any questions.",
    'Thank you for checking out the site and we wish to see you around!'
  ],
  rating: 'quick rating',
  email: 'email us',
  any_content: 'any content',
  operators: 'use operators',
  videoerror: 'You need an HTML 5-capable browser to view the tutorial.',
}